import usePrismicContent from './usePrismicContent';
import usePrismicCustomerData from './usePrismicCustomerData';

const usePrismicSelector = () => {
    usePrismicCustomerData();
    return usePrismicContent();
};

export default usePrismicSelector;
